import { render, staticRenderFns } from "./dataUpIE9.vue?vue&type=template&id=663dfeb0"
import script from "./dataUpIE9.vue?vue&type=script&lang=js"
export * from "./dataUpIE9.vue?vue&type=script&lang=js"
import style0 from "./dataUpIE9.vue?vue&type=style&index=0&id=663dfeb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports